import "bootstrap/dist/css/bootstrap.min.css";
import { onValue, ref } from "firebase/database";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../Firebase";

const LoginSelect = () => {
  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [login, setLogin] = useState({
    role: "",
    username: "",
    password: "",
  });

  /* ================= HANDLE BACK BUTTON ================= */
  useEffect(() => {
    const handleBackButton = (e) => {
      e.preventDefault();
      navigate('/');
    };

    window.history.pushState(null, '', window.location.pathname);
    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [navigate]);

  /* ================= FETCH USERS ================= */
  useEffect(() => {
    const usersRef = ref(db, "passwords");

    onValue(usersRef, (snap) => {
      if (snap.exists()) {
        setUsers(Object.values(snap.val()));
      }
    });
  }, []);

  /* ================= HANDLE CHANGE ================= */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setLogin((prev) => ({ ...prev, [name]: value }));
  };

  /* ================= LOGIN ================= */
  const handleLogin = () => {
    if (!login.role) {
      alert("⚠️ Please select login type");
      return;
    }

    const foundUser = users.find(
      (u) =>
        u.role === login.role &&
        (u.email === login.username || u.phone === login.username) &&
        u.password === login.password
    );

    if (!foundUser) {
      alert("❌ Invalid Credentials");
      return;
    }

    // set expiry for auto-logout (20 minutes)
    const userToStore = { ...foundUser, expiry: Date.now() + 20 * 60 * 1000 };
    localStorage.setItem("loggedUser", JSON.stringify(userToStore));

    /* ===== ROLE BASED NAVIGATION ===== */
    if (login.role === "Admin") navigate("/Amain");
    else if (login.role === "Dashboard View") navigate("/dashboard-view");
    else if (login.role === "Employee") navigate("/employee-dashboard");
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #F3F4F6, #E5E7EB, #D1D5DB)",
      }}
    >
      <div
        className="card shadow-lg p-4"
        style={{
          width: "380px",
          borderRadius: "16px",
          border: "1px solid #213F6D",
          position: "relative"
        }}
      >
        {/* Close Button */}
        <button
          onClick={() => navigate('/')}
          className="position-absolute"
          style={{
            top: "10px",
            right: "10px",
            width: "35px",
            height: "35px",
            borderRadius: "4px",
            padding: "0",
            fontSize: "20px",
            fontWeight: "bold",
            zIndex: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#ffcccb",
            border: "1px solid #ff9999",
            color: "#cc0000",
            cursor: "pointer"
          }}
          aria-label="Close"
        >
          ×
        </button>
        <div className="text-center mb-3">
          <img src="/Logo.png" alt="Logo" height="80" />
        </div>

        <h4 className="text-center mb-4 fw-bold" style={{ color: "#213F6D" }}>
          Login
        </h4>

        {/* ===== LOGIN TYPE ===== */}
<div className="mb-4">
  <label className="form-label fw-semibold text-secondary mb-1">
    Login Type
  </label>

  <div className="position-relative">
    <i
      className="bi bi-person-badge position-absolute"
      style={{
        top: "50%",
        left: "14px",
        transform: "translateY(-50%)",
        color: "#213F6D",
        zIndex: 2
      }}
    ></i>

    <select
      className="form-select"
      name="role"
      value={login.role}
      onChange={handleChange}
      style={{
        borderRadius: "12px",
        height: "48px",
        border: "1px solid #213F6D",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        paddingLeft: "45px"
      }}
    >
      <option value="">Select Login Type</option>
      <option value="Admin">🔐 Admin</option>
      <option value="Dashboard View">📊 Dashboard View</option>
      <option value="Employee">👨‍💼 Employee</option>
    </select>
  </div>
</div>


        {/* ===== USERNAME ===== */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Email / Phone</label>
          <input
            className="form-control"
            name="username"
            value={login.username}
            onChange={handleChange}
            placeholder="Enter Email or Phone"
          />
        </div>

        {/* ===== PASSWORD ===== */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Password</label>
          <input
            type="password"
            className="form-control"
            name="password"
            value={login.password}
            onChange={handleChange}
            placeholder="Enter Password"
          />
        </div>

        <button
          onClick={handleLogin}
          className="btn w-100 fw-semibold text-white"
          style={{ backgroundColor: "#213F6D" }}
        >
          Login
        </button>

        <div className="text-center mt-3 text-dark small">
          Forgot Password? Contact admin to reset your password:
          <div>
            <a href="mailto:admin@example.com" className="text-primary">admin@example.com</a>
            <span className="mx-2">|</span>
            <a href="tel:+911234567890" className="text-primary">+91 12345 67890</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginSelect;
